import { useAuth } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { LegalGate } from "@/components/LegalGate";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-slate-400 text-sm">Loading…</div>
      </div>
    );
  }
  if (!user) {
    // Rep-facing routes route to the rep-branded login; everything else
    // falls back to the detailer login.
    const path = location.pathname || "";
    const isRepPath = path.startsWith("/rep");
    return <Navigate to={isRepPath ? "/rep/login" : "/login"} replace />;
  }
  return (
    <>
      <LegalGate />
      {children}
    </>
  );
}
